<script setup>
import Tooltip from "../Tooltip.vue";

const props = defineProps({
  tooltipText: {
    type: String,
    required: false,
    default: "",
  },
});
</script>

<template>
  <td class="p-4 align-middle [&:has([role=checkbox])]:pr-0">
    <template v-if="tooltipText">
      <Tooltip :text="tooltipText" :follow-cursor="true" class="block h-full w-full">
        <slot />
      </Tooltip>
    </template>
    <template v-else>
      <slot />
    </template>
  </td>
</template>
